import type { CoursesLogPdfLoadFailureDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	LogPdfLoadFailureInput,
	LogPdfLoadFailureOutput,
} from '../../types/pdf-error-logging.types';

const TAG = 'courses:pdf-error-logging' as const;
const INVALIDATES = [TAG] as const;

export const pdfErrorLoggingEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		logPdfLoadFailure: builder.mutation<LogPdfLoadFailureOutput, LogPdfLoadFailureInput>({
			query: (body) => ({
				url: 'courses/client-logs/pdf-load-failure',
				method: 'POST',
				body: body satisfies Wire<CoursesLogPdfLoadFailureDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
	}),
});

export const { useLogPdfLoadFailureMutation } = pdfErrorLoggingEndpoints;
